import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import _ from 'lodash';
import { SamwinCallInfoRemoteDto } from 'src/generated/signalR/samwin-call-info-remote-dto';
import { SkillConfigurationRemoteDto } from 'src/generated/swagger/model/skillConfigurationRemoteDto';
import { SamwinAcdExtensionStateSelectors } from '../samwin-acd-extension/samwin-acd-extension.selectors';
import { SamwinLinesStateSelector } from '../samwin-lines/samwin-lines.selector';
import { SamwinSkillsState } from './samwin-skills.state';

@Injectable()
export class SamwinSkillsSelectors {
   constructor() {}

   @Selector([
      SamwinAcdExtensionStateSelectors.getCurrentAcdSkillID,
      SamwinSkillsState.getSkillConfigurationFn,
      SamwinSkillsState.getSkillConfigurationOfCurrentCall,
   ])
   public static getCurrentAcdOrCallSkillConfiguration(
      acdSkillId: number,
      getSkillById: (skillId: number) => SkillConfigurationRemoteDto,
      currentCallSkill: SkillConfigurationRemoteDto
   ) {
      if (!_.isNil(currentCallSkill)) {
         return currentCallSkill;
      }
      const acdSkill = getSkillById(acdSkillId);
      if (!_.isNil(acdSkill)) {
         return acdSkill;
      }
      return null;
   }

   @Selector([SamwinLinesStateSelector.getCallerInfoFromCurrentOrPreviousCall, SamwinAcdExtensionStateSelectors.getCurrentAcdSkillID])
   public static getRequestingSkillIdForEmail(callerInfo: SamwinCallInfoRemoteDto, defaultSkillIdFromAcd: number): number {
      if (callerInfo?.queueId > 0) {
         return callerInfo.queueId;
      }

      return defaultSkillIdFromAcd;
   }
}
